// Export route configurations from feature-based route files
export * from './auth-routes';
export * from './organization-routes';
export * from './admin-routes';
export * from './setup-routes';
export * from './app-routes';

// Root routes object that combines all route configurations
import {
  authRoutes,
  publicFormRoutes,
  publicEventRoutes,
  publicListShareRoutes,
  publicProjectStatusRoutes,
  publicBookingRoutes,
  publicKbRoutes,
  publicQuoteRoutes,
} from './auth-routes';
import { organizationRoutes } from './organization-routes';
import { adminRoutes } from './admin-routes';
import { setupRoutes } from './setup-routes';
import { appRoutes } from './app-routes';
import { AppRouteObject } from '../types';

// Public form routes - use lightweight PublicRoot wrapper (no auth, sockets, etc.)
// These are exported separately for use with PublicRoot in App.tsx
export { publicFormRoutes, publicEventRoutes, publicListShareRoutes, publicProjectStatusRoutes, publicBookingRoutes, publicKbRoutes, publicQuoteRoutes };

// App routes - require full Root wrapper with all providers
// Order matters: most specific routes should come first
// appRoutes must come BEFORE organizationRoutes because /:orgSlug/* would catch /tray-tasks
export const appOnlyRoutes: AppRouteObject[] = [
  ...authRoutes,
  ...setupRoutes,
  ...adminRoutes,      // Admin routes should come before organization routes
  ...appRoutes,        // Global app routes (tray-tasks, settings, etc.) before org routes
  ...organizationRoutes, // /:orgSlug/* catch-all must be last
];

// Combined routes for backwards compatibility (if needed)
// Note: App.tsx now uses separate route trees for public vs app routes
export const routes: AppRouteObject[] = [
  ...publicFormRoutes, // Public forms - highest priority
  ...publicEventRoutes, // Public events - before org routes
  ...publicListShareRoutes, // Public shared lists - before org routes
  ...appOnlyRoutes,
];
